<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <div v-if="nuevo" class="col-xs-12 col-md-12">
          <input-field class="input-field--stretch" id="numeroContenedor" v-model="form.number" bold fontSize="150%">
            <h3 style="color:black">Unidad</h3>
            <span v-if="errores.number" class="helper-text text-danger" slot="helper">
              <strong>{{ errores.number[0] }}</strong>
            </span>
          </input-field>
        </div>
        <h3 v-else>
          <!-- <button
            type="button"
            class="btn-info btn--text"
            @click="verFotos(numeroContenedor)"
          >
            {{ numeroContenedor }}
          </button> -->
          <a @click="verFotos" href="#">
            Unidad {{ numeroContenedor }}
          </a>
          <!-- Unidad {{ numeroContenedor }} -->
        </h3>
      </div>
      <div class="layout__controls">
        <div class="form-inline">
          <button class="btn-success" type="button" v-if="!MostrarBotonGuardar" @click="actualizar">
            <i class="fa fa-check"></i>
            <span>Guardar</span>
          </button>
          <button class="btn-success" type="button" v-else @click="crear">
            <i class="fa fa-check"></i>
            <span>Guardar</span>
          </button>
          <button :disabled="finalizando" class="btn-primary" type="button" v-if="puede_finalizar_in && nuevo && !MostrarBotonGuardar" @click="finalizar">
            <i class="fa fa-check"></i>
            <span>Finalizar</span>
          </button>
          <button @click="imprimirEirIn" v-show="form.in.eir && !MostrarBotonGuardar" class="btn--outline btn-info">
            <span>EIR caja</span>
          </button>
          <button @click="imprimirEirMaquina" v-show="form.in.eir_maquina" class="btn--outline btn-secondary">
            <span>EIR máquina</span>
          </button>
          <button @click="imprimirEirOut" v-show="form.out.eir" class="btn--outline btn-success">
            <span>EIR out</span>
          </button>
          <button @click="generarEDI('IN')" v-show="!MostrarBotonGuardar && puede_enviar_edi_in" class="btn--outline btn-info">
            <span>EDI in</span>
          </button>
          <button @click="generarEDI('OUT')" v-show="!outDisabled && tipo_registro !== 'OUT' && puede_enviar_edi_out" class="btn--outline btn-secondary">
            <span>EDI out</span>
          </button>
          <button class="btn-primary btn--outline" type="button" v-if="!MostrarBotonGuardar && puede_editar_detalles" @click="mostrarDetalles">
            <i class="fa fa-table"></i>
            <span>Detalles</span>
          </button>
          <button class="btn-secondary btn--text" type="button" v-if="nuevo" @click="nuevoRegistro">
            <i class="fa fa-plus"></i>
            <span>Nuevo</span>
          </button>
          <button class="btn-danger" type="button" v-show="puede_eliminar && !MostrarBotonGuardar"
            @click="eliminarUnidad">
            <i class="fa fa-ban"></i>
            <span>Eliminar</span>
          </button>
          <button class="btn-danger btn--text" type="button" v-if="!nuevo" @click="cerrarUnidad">
            <i class="fa fa-ban"></i>
            <span>Cancelar</span>
          </button>
          <button class="btn-info btn--text" type="button" @click="mostrarAtajos">
            <i class="fa fa-question-circle "></i>
            <span>Atajos</span>
          </button>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card__content">
        <div class="layout__main-form">
          <details class="card card--collapsible mt-3 mb-3" id="IN">
            <summary class="card__title card__title--bg-success">
              <h5>IN</h5>
            </summary>
            <div class="card__content">
              <div class="row">
                <div class="col-xs-12 col-md-3">
                  <div class="form-field">
                    <input-field stretch :value="this.form.number" readonly id="number">Number:</input-field>
                  </div>
                </div>
                <div class="col-xs-12 col-md-3" v-show="nuevo">
                  <div class="form-field select2" :class="{ 'select2--disabled': tipo_registro === 'OUT' }">
                    <div class="select2-field select2-field--stretch">
                      <v-select @input="inputYard" v-model="selectedYard" id="yard" label="name" :options="yards"
                        :disabled="total_loss || !puede_editar_in"></v-select>
                      <label for="yard">Yard:</label>
                      <span v-if="errores.yard_code" class="helper-text text-danger" slot="helper">
                        <strong>{{ errores.yard_code[0] }}</strong>
                      </span>
                    </div>
                  </div>
                </div>
                <div class="col-xs-12 col-md-3">
                  <div class="form-field">
                    <input-field stretch v-model="form.in.turn_in" id="turn_in" :disabled="total_loss || !puede_editar_in"
                      :readonly="tipo_registro === 'OUT'">Turn IN:</input-field>
                  </div>
                </div>
                <div class="col-xs-12 col-md-3">
                  <div class="form-field">
                    <input-field stretch v-model="form.in.eir" id="eir" :disabled="total_loss || !puede_editar_in"
                      :readonly="tipo_registro === 'OUT'">Eir:</input-field>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12 col-md-3">
                  <div class="form-field select2" :class="{ 'select2--disabled': tipo_registro === 'OUT' }">
                    <div class="select2-field select2-field--stretch">
                      <v-select :disabled="total_loss || !puede_editar_in" v-model="form.in.size" id="size" label="size" :options="sizes">
                      </v-select>
                      <label for="size">Size:</label>
                    </div>
                  </div>
                </div>
                <div class="col-xs-12 col-md-3">
                  <div class="form-field select2" :class="{ 'select2--disabled': tipo_registro === 'OUT' }">
                    <div class="select2-field select2-field--stretch">
                      <v-select @input="inputType" v-model="selectedType" id="type" label="descripcion" :options="types"
                        :disabled="total_loss || !puede_editar_in"></v-select>
                      <label for="type">Type:</label>
                      <span v-if="errores['in.type_container_code']" class="helper-text text-danger" slot="helper">
                        <strong>{{ errores['in.type_container_code'][0] }}</strong>
                      </span>
                    </div>
                  </div>
                </div>
                <div class="col-xs-12 col-md-3">
                  <div class="datepicker-field datepicker-field--stretch">
                    <date-picker id="gate_date_in" type="dateTime" locale="es" format="YYYY-MM-DD HH:mm"
                      formatted="YYYY-MM-DD HH:mm" v-model="form.in.gate_date"
                      :disabled="total_loss || !puede_editar_in || tipo_registro === 'OUT' || (!MostrarBotonGuardar && !puede_editar_gate_in)">
                    </date-picker>
                    <label>Gate Date:</label>
                    <span v-if="errores['in.gate_date']" class="helper-text text-danger" slot="helper">
                      <strong>{{ errores['in.gate_date'][0] }}</strong>
                    </span>
                  </div>
                </div>
                <div class="col-xs-12 col-md-3">
                  <div class="form-field">
                    <input-field :disabled="total_loss || !puede_editar_in" :readonly="tipo_registro === 'OUT'" stretch
                      v-model="form.in.tara" id="tara">Tara</input-field>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12 col-md-3">
                  <div class="form-field">
                    <input-field stretch :disabled="total_loss || !puede_editar_in" :readonly="tipo_registro === 'OUT'"
                      v-model="form.in.gross" id="gross">Gross</input-field>
                  </div>
                </div>
                <div class="col-xs-12 col-md-3">
                  <div class="form-field">
                    <input-field stretch :disabled="total_loss || !puede_editar_in" :readonly="tipo_registro === 'OUT'"
                      v-model="form.in.booking" id="booking_in">
                      Booking:
                      <span v-if="errores['in.booking']" class="helper-text text-danger" slot="helper">
                        <strong>{{ errores['in.booking'][0] }}</strong>
                      </span>
                    </input-field>
                  </div>
                </div>
                <div class="col-xs-12 col-md-3">
                  <div class="form-field select2" :class="{ 'select2--disabled': tipo_registro === 'OUT' }">
                    <div class="select2-field select2-field--stretch">
                      <v-select @input="inputTruckCo" id="trucking_in" @search="fetchTruckingIn" v-model="form.in.truck_co"
                        :options="optionsTruckingIn" :disabled="total_loss || !puede_editar_in" taggable></v-select>
                      <label for="truckIn">Truck Co:</label>
                    </div>
                  </div>
                </div>
                <div class="col-xs-12 col-md-3">
                  <div class="form-field">
                    <input-field :disabled="total_loss || !puede_editar_in" :readonly="tipo_registro === 'OUT'" stretch
                      v-model="form.in.cedula_conductor" id="cedula_conductor_in">C.I_Conductor:</input-field>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12 col-md-3">
                  <div class="form-field select2" :class="{ 'select2--disabled': tipo_registro === 'OUT' }">
                    <div class="select2-field select2-field--stretch">
                      <v-select @input="inputShipper" id="shipper_in" @search="fetchShipperIn" v-model="form.in.shipper"
                        :options="optionsShipperIn" :disabled="total_loss || !puede_editar_in" taggable></v-select>
                      <label for="shipper">Shipper:</label>
                      <span v-if="errores['in.shipper']" class="helper-text text-danger" slot="helper">
                        <strong>{{ errores['in.shipper'][0] }}</strong>
                      </span>
                    </div>
                  </div>
                </div>
                <div class="col-xs-12 col-md-3">
                  <div class="form-field select2" :class="{ 'select2--disabled': tipo_registro === 'OUT' }">
                    <div class="select2-field select2-field--stretch">
                      <v-select @input="inputVessel" id="vessel" @search="fetchVesselIn" v-model="form.in.vessel" :options="optionsVesselIn"
                        :disabled="total_loss || !puede_editar_in" taggable></v-select>
                      <label for="vessel">Vessel:</label>
                    </div>
                  </div>
                </div>
                <div class="col-xs-12 col-md-3">
                  <div class="form-field select2" :class="{ 'select2--disabled': tipo_registro === 'OUT' }">
                    <div class="select2-field select2-field--stretch">
                      <v-select @input="inputCustomer" id="customer" v-model="selectedCustomer" :options="customers"
                        label="nombre" :disabled="total_loss || !puede_editar_in || !MostrarBotonGuardar"></v-select>
                      <label for="customer">Customer:</label>
                    </div>
                  </div>
                </div>
                <div class="col-xs-12 col-md-3">
                  <div class="form-field select2" :class="{ 'select2--disabled': tipo_registro === 'OUT' }">
                    <div class="select2-field select2-field--stretch">
                      <v-select :disabled="total_loss || !puede_editar_in" v-model="form.in.type_dmg" :options="damages" id="type_dmg">
                      </v-select>
                      <label for="type_dmg">Type Dmg:</label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12 col-md-3">
                  <div class="form-field select2" :class="{ 'select2--disabled': tipo_registro === 'OUT' }">
                    <div class="select2-field select2-field--stretch">
                      <v-select :disabled="total_loss || !puede_editar_in" id="model_box" v-model="form.in.model_box" :options="modelBox">
                      </v-select>
                      <label for="model_box">Model Box:</label>
                    </div>
                  </div>
                </div>
                <div class="col-xs-12 col-md-3">
                  <div class="form-field">
                    <input-field :disabled="total_loss || !puede_editar_in" :readonly="tipo_registro === 'OUT'" stretch
                      v-model="form.in.placa" id="placa">Placa:</input-field>
                  </div>
                </div>
                <div class="col-xs-12 col-md-4" v-show="false">
                  <div class="form-field mt-2">
                    <label class="input-field__label" for="archivo">Foto de cédula</label>
                    <input type="file" accept="image/*" @change="imgSelected" name="archivo" id="archivo">
                  </div>
                </div>
                <div class="col-xs-12 col-md-2" v-if="imagePreview">
                  <button class="btn-secondary btn--text" type="button" @click="mostrarImg">
                    <i class="fa fa-eye"></i>
                  </button>
                  <!-- <img :src="imagePreview" class="figure-img img-fluid rounded" style="max-height: 100px;"> -->
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12 col-md-12">
                  <div class="form-field">
                    <textarea-field :disabled="total_loss || !puede_editar_in" :readonly="tipo_registro === 'OUT'" stretch
                      v-model="form.in.remarks" id="remarks">Remarks:</textarea-field>
                  </div>
                </div>
              </div>
              <div class="row">
                <div>
                  <label class="col-xs-12 col-md-2">
                    <input :disabled="total_loss || !puede_editar_in || tipo_registro === 'OUT'" v-model="form.in.raps" type="checkbox" />
                    <span>RAPS</span>
                  </label>
                  <label class="col-xs-12 col-md-3">
                    <input :disabled="total_loss || !puede_editar_in || tipo_registro === 'OUT'" v-model="form.in.damage" type="checkbox" />
                    <span>Damage</span>
                  </label>
                  <label class="col-xs-12 col-md-2">
                    <input :disabled="total_loss || !puede_editar_in || tipo_registro === 'OUT'" v-model="form.in.pti" type="checkbox" />
                    <span>PTI</span>
                  </label>
                  <label class="col-xs-12 col-md-2">
                    <input :disabled="total_loss || !puede_editar_in || tipo_registro === 'OUT'" v-model="form.in.full" type="checkbox" />
                    <span>Full</span>
                  </label>
                  <label class="col-xs-12 col-md-2">
                    <input :disabled="total_loss || !puede_editar_in || tipo_registro === 'OUT'" v-model="form.in.automatico"
                      type="checkbox" />
                    <span>Automático</span>
                  </label>
                </div>
                <div>
                  <label class="col-xs-12 col-md-2">
                    <b>Type:</b>
                  </label>
                  <label class="col-xs-12 col-md-2">
                    <input v-model="form.in.type" type="radio" name="type_in" id="type_pto" value="CY"
                      :disabled="total_loss || !puede_editar_in || tipo_registro === 'OUT'" />
                    <span>PTO</span>
                  </label>
                  <label class="col-xs-12 col-md-2">
                    <input v-model="form.in.type" type="radio" name="type_in" id="type_dev" value="CF"
                      :disabled="total_loss || !puede_editar_in || tipo_registro === 'OUT'" />
                    <span>DEV</span>
                  </label>
                  <label class="col-xs-12 col-md-2">
                    <input v-model="form.in.type" type="radio" name="type_in" id="type_ccl" value="SD"
                      :disabled="total_loss || !puede_editar_in || tipo_registro === 'OUT'" />
                    <span>CCL</span>
                  </label>
                  <label class="col-xs-12 col-md-2">
                    <input v-model="form.in.type" type="radio" name="type_in" id="type_pos" value="PO"
                      :disabled="total_loss || !puede_editar_in || tipo_registro === 'OUT'" />
                    <span>POS</span>
                  </label>
                  <label class="col-xs-12 col-md-2">
                    <input v-model="form.in.type" type="radio" name="type_in" id="type_acc" value="AC"
                      :disabled="total_loss || !puede_editar_in || tipo_registro === 'OUT'" />
                    <span>ACC</span>
                  </label>
                  <label v-if="errores['in.type']">
                    <span slot="helper" class="helper-text text-danger" style="width: auto;">
                      <strong>{{ errores['in.type'][0] }}</strong>
                    </span>
                  </label>
                </div>
              </div>
            </div>
          </details>
          <details class="card card--collapsible mt-3 mb-3" id="OUT">
            <summary class="card__title card__title--bg-info">
              <h5>OUT</h5>
            </summary>
            <div class="card__content">
              <div class="row">
                <div class="col-xs-12 col-md-3">
                  <div class="datepicker-field datepicker-field--stretch">
                    <date-picker id="gate_date_out" type="dateTime" locale="es" format="YYYY-MM-DD HH:mm"
                      formatted="YYYY-MM-DD HH:mm" v-model="form.out.gate_date"
                      :disabled="total_loss || !puede_editar_out || outDisabled || (!MostrarBotonGuardar && !puede_editar_gate_out && tipo_registro !== 'OUT')">
                    </date-picker>
                    <label>Gate Date:</label>
                  </div>
                </div>
                <div class="col-xs-12 col-md-3">
                  <div class="form-field">
                    <input-field :disabled="total_loss || !puede_editar_out" :readonly="outDisabled" stretch id="turn_out"
                      v-model="form.out.turn_out">Turn OUT:</input-field>
                  </div>
                </div>
                <div class="col-xs-12 col-md-3">
                  <div class="form-field">
                    <input-field :disabled="total_loss || !puede_editar_out" :readonly="outDisabled" stretch id="e_ir_out"
                      v-model="form.out.eir">Eir:</input-field>
                  </div>
                </div>
                <div class="col-xs-12 col-md-3">
                  <div class="form-field">
                    <input-field :disabled="total_loss || !puede_editar_out" :readonly="outDisabled" stretch id="booking_out"
                      v-model="form.out.booking">
                      Booking
                      <span v-if="errores['out.booking']" class="helper-text text-danger" slot="helper">
                        <strong>{{ errores['out.booking'][0] }}</strong>
                      </span>
                    </input-field>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12 col-md-3">
                  <div class="form-field">
                    <input-field stretch :disabled="total_loss || !puede_editar_out" :readonly="outDisabled" id="vessel_out"
                      v-model="form.out.vessel">Vessel</input-field>
                  </div>
                </div>
                <div class="col-xs-12 col-md-3">
                  <div class="form-field select2" :class="{ 'select2--disabled': outDisabled }">
                    <div class="select2-field select2-field--stretch">
                      <v-select @input="inputShipperOut" id="shipper_out" @search="fetchShipperOut" v-model="form.out.shipper"
                        :options="optionsShipperOut" :disabled="total_loss || !puede_editar_out" taggable></v-select>
                      <label for="shipper_out">Shipper:</label>
                    </div>
                  </div>
                </div>
                <div class="col-xs-12 col-md-3">
                  <div class="form-field select2" :class="{ 'select2--disabled': outDisabled }">
                    <div class="select2-field select2-field--stretch">
                      <v-select @input="inputTruckCoOut" id="truck_out" @search="fetchTruckingOut" v-model="form.out.truck_co"
                        :options="optionsTruckingOut" :disabled="total_loss || !puede_editar_out" taggable></v-select>
                      <label for="truck_co_out">Truck Co:</label>
                    </div>
                  </div>
                </div>
                <div class="col-xs-12 col-md-3">
                  <div class="form-field">
                    <input-field stretch :disabled="total_loss || !puede_editar_out" :readonly="outDisabled"
                      v-model="form.out.cedula_conductor" id="cedula_conductor_out">C.I_Conductor:</input-field>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12 col-md-3">
                  <div class="form-field">
                    <input-field stretch :disabled="total_loss || !puede_editar_out" :readonly="outDisabled" id="voyage_out"
                      v-model="form.out.voyage">Voyage</input-field>
                  </div>
                </div>
                <div class="col-xs-12 col-md-3">
                  <div class="form-field">
                    <input-field stretch :disabled="total_loss || !puede_editar_out" :readonly="outDisabled" id="payload_out"
                      v-model="form.out.payload">Payload</input-field>
                  </div>
                </div>
                <div class="col-xs-12 col-md-3">
                  <div class="form-field select2" :class="{ 'select2--disabled': outDisabled }">
                    <div class="select2-field select2-field--stretch">
                      <v-select @input="inputChassisOut" id="chassis_out" v-model="form.out.chassis" :options="chassis" :disabled="total_loss || !puede_editar_out"
                        taggable></v-select>
                      <label for="chassis">Chassis:</label>
                    </div>
                  </div>
                </div>
                <div class="col-xs-12 col-md-3">
                  <div class="form-field">
                    <input-field stretch :disabled="total_loss || !puede_editar_out" :readonly="outDisabled" id="placa_out"
                      v-model="form.out.placa">Placa Out</input-field>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12 col-md-3">
                  <div class="form-field">
                    <input-field stretch id="sticker_seal_out" v-model="form.out.sticker_seal" :disabled="total_loss || !puede_editar_out"
                      :readonly="outDisabled">Sticker Seal</input-field>
                  </div>
                </div>
                <div class="col-xs-12 col-md-3">
                  <div class="form-field">
                    <input-field stretch id="bottle_pack_out" v-model="form.out.bottle_pack" :disabled="total_loss || !puede_editar_out"
                      :readonly="outDisabled">Bottle Pack/Kit seal</input-field>
                  </div>
                </div>
                <div class="col-xs-12 col-md-3">
                  <div class="form-field">
                    <input-field stretch :disabled="total_loss || !puede_editar_out" :readonly="outDisabled" id="bottle_seal_out"
                      v-model="form.out.bottle_seal">Bottle Seal</input-field>
                  </div>
                </div>
                <div class="col-xs-12 col-md-3">
                  <div class="form-field">
                    <input-field stretch :disabled="total_loss || !puede_editar_out" :readonly="outDisabled" v-model="form.out.plastic"
                      id="plastic">Plastic/lata seal:</input-field>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="mt-2 mr-2">
                  <label class="col-xs-12 col-md-3">
                    <b>Type:</b>
                  </label>
                  <label class="col-xs-12 col-md-2">
                    <input v-model="form.out.type" type="radio" name="type_out" id="type_exp" value="EXP"
                      :disabled="total_loss || !puede_editar_out || outDisabled" />
                    <span>EXP</span>
                  </label>
                  <label class="col-xs-12 col-md-2">
                    <input v-model="form.out.type" type="radio" name="type_out" id="type_pos" value="POS"
                      :disabled="total_loss || !puede_editar_out || outDisabled" />
                    <span>POS</span>
                  </label>
                  <label class="col-xs-12 col-md-2">
                    <input v-model="form.out.type" type="radio" name="type_out" id="type_pla" value="PLA"
                      :disabled="total_loss || !puede_editar_out || outDisabled" />
                    <span>PLA</span>
                  </label>
                </div>
                <div class="col-xs-12 col-md-2">
                  <div class="form-field">
                    <input-field :disabled="total_loss || !puede_editar_out" :readonly="outDisabled" stretch id="ventilacion_out"
                      v-model="form.out.ventilacion">Ventilación</input-field>
                  </div>
                </div>
                <div class="col-xs-12 col-md-2">
                  <div class="form-field">
                    <input-field :disabled="total_loss || !puede_editar_out" :readonly="outDisabled" stretch id="te_out"
                      v-model="form.out.te">Te</input-field>
                  </div>
                </div>
                <div class="col-xs-12 col-md-1">
                  <div class="form-field">
                    <p>
                      <label>
                        <input type="checkbox" v-model="form.out.full" :disabled="total_loss || !puede_editar_out || outDisabled" />
                        <span>Full</span>
                      </label>
                    </p>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12 col-md-12">
                  <div class="form-field">
                    <textarea-field stretch :disabled="total_loss || !puede_editar_out" :readonly="outDisabled" id="remarks_out"
                      v-model="form.out.remarks">Remarks:</textarea-field>
                  </div>
                </div>
              </div>
            </div>
          </details>
          <details class="card card--collapsible mt-3 mb-3" id="MAC">
            <summary class="card__title card__title--bg-secondary">
              <h5>Machine</h5>
            </summary>
            <div class="card__content">
              <div class="row">
                <div class="col-xs-12 col-md-3">
                  <div class="form-field">
                    <p>
                      <label>
                        <input type="checkbox" @change="changeInspeccionM" v-model="form.mac.inspection"
                          :disabled="total_loss || !puede_editar_maquina" />
                        <span>Inspection</span>
                      </label>
                    </p>
                  </div>
                </div>
                <div class="col-xs-12 col-md-3">
                  <div class="form-field">
                    <div class="datepicker-field datepicker-field--stretch">
                      <date-picker id="date_inspection_m" locale="es" v-model="form.mac.inspection_date"
                        :disabled="total_loss || !puede_editar_maquina"></date-picker>
                      <label>Date:</label>
                      <span v-if="errores['mac.inspection_date']" class="helper-text text-danger" slot="helper">
                        <strong>Este campo es requerido cuando selecciona inspection</strong>
                      </span>
                    </div>
                  </div>
                </div>
                <div class="col-xs-12 col-md-3">
                  <div class="form-field">
                    <input-field stretch :disabled="total_loss || !puede_editar_maquina" id="hour_man_m" v-model="form.mac.hour_man">Hour Man:
                    </input-field>
                  </div>
                </div>
                <div class="col-xs-12 col-md-3">
                  <div class="form-field">
                    <div class="datepicker-field datepicker-field--stretch">
                      <date-picker id="in_servi" type="dateTime" locale="es" format="YYYY-MM-DD HH:mm"
                        formatted="YYYY-MM-DD HH:mm" v-model="form.mac.in_servi" :disabled="total_loss || !puede_editar_maquina"></date-picker>
                      <label>In Servi</label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12 col-md-3">
                  <div class="form-field">
                    <p>
                      <label>
                        <input type="checkbox" @change="changeEstimateM" v-model="form.mac.estimate"
                          :disabled="total_loss || !puede_editar_maquina" />
                        <span>Estimate</span>
                      </label>
                    </p>
                  </div>
                </div>
                <div class="col-xs-12 col-md-3">
                  <div class="form-field">
                    <div class="datepicker-field datepicker-field--stretch">
                      <date-picker id="date_estimate_m" locale="es" v-model="form.mac.estimate_date"
                        :disabled="total_loss || !puede_editar_maquina"></date-picker>
                      <label>Date:</label>
                      <span v-if="errores['mac.estimate_date']" class="helper-text text-danger" slot="helper">
                        <strong>Este campo es requerido cuando selecciona estimate</strong>
                      </span>
                    </div>
                  </div>
                </div>
                <div class="col-xs-12 col-md-3">
                  <div class="form-field">
                    <input-field stretch vMoney :format="decimal2" :disabled="total_loss || !puede_editar_maquina" id="amount_m"
                      v-model="form.mac.amount">Amount:</input-field>
                  </div>
                </div>
                <div class="col-xs-12 col-md-3">
                  <div class="form-field select2">
                    <div class="select2-field select2-field--stretch">
                      <v-select id="pti_type" label="name" @input="inputPtiType" v-model="selectedPtiType"
                        :options="OptionsPtiTypes" :disabled="total_loss || !puede_editar_maquina"></v-select>
                      <label for="pti_type">Pti Type:</label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12 col-md-3">
                  <div class="form-field">
                    <p>
                      <label>
                        <input type="checkbox" @change="changeApprovedM" v-model="form.mac.approved"
                          :disabled="total_loss || !puede_editar_maquina" />
                        <span>Approved</span>
                      </label>
                    </p>
                  </div>
                </div>
                <div class="col-xs-12 col-md-3">
                  <div class="form-field">
                    <div class="datepicker-field datepicker-field--stretch">
                      <date-picker id="date_approved_m" locale="es" v-model="form.mac.approved_date"
                        :disabled="total_loss || !puede_editar_maquina"></date-picker>
                      <label>Date:</label>
                      <span v-if="errores['mac.approved_date']" class="helper-text text-danger" slot="helper">
                        <strong>Este campo es requerido cuando selecciona approved</strong>
                      </span>
                    </div>
                  </div>
                </div>
                <div class="col-xs-12 col-md-3">
                  <div class="form-field select2">
                    <div class="select2-field select2-field--stretch">
                      <v-select @input="inputModelMachine" id="model_machine" taggable v-model="form.mac.model_machine" :options="modelMachine"
                        :disabled="total_loss || !puede_editar_maquina"></v-select>
                      <label for="model_machine">Model Machine:</label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12 col-md-3">
                  <div class="form-field">
                    <p>
                      <label>
                        <input :disabled="total_loss || !puede_editar_maquina" type="checkbox" @change="changeInvoiceM"
                          v-model="form.mac.invoice" />
                        <span>Invoice</span>
                      </label>
                    </p>
                  </div>
                </div>
                <div class="col-xs-12 col-md-3">
                  <div class="form-field">
                    <div class="datepicker-field datepicker-field--stretch">
                      <date-picker id="date_invoice_m" locale="es" v-model="form.mac.invoice_date"
                        :disabled="total_loss || !puede_editar_maquina"></date-picker>
                      <label>Date:</label>
                      <span v-if="errores['mac.invoice_date']" class="helper-text text-danger" slot="helper">
                        <strong>Este campo es requerido cuando selecciona invoice</strong>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12 col-md-3">
                  <div class="form-field">
                    <p>
                      <label>
                        <input type="checkbox" @change="changeRepairedM" v-model="form.mac.repaired"
                          :disabled="total_loss || !puede_editar_maquina" />
                        <span>Repaired</span>
                      </label>
                    </p>
                  </div>
                </div>
                <div class="col-xs-12 col-md-3">
                  <div class="form-field">
                    <div class="datepicker-field datepicker-field--stretch">
                      <date-picker id="date_repaired_m" locale="es" v-model="form.mac.repaired_date"
                        :disabled="total_loss || !puede_editar_maquina"></date-picker>
                      <label>Date:</label>
                      <span v-if="errores['mac.repaired_date']" class="helper-text text-danger" slot="helper">
                        <strong>Este campo es requerido cuando selecciona repaired</strong>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12 col-md-12">
                  <div class="form-field">
                    <textarea-field stretch :disabled="total_loss || !puede_editar_maquina" v-model="form.mac.remarks" id="remarks_m">Remarks:
                    </textarea-field>
                  </div>
                </div>
              </div>
            </div>
          </details>
          <details class="card card--collapsible mt-3 mb-3" id="BOX">
            <summary class="card__title card__title--bg-warning">
              <h5>Box</h5>
            </summary>
            <div class="card__content">
              <div class="row">
                <div class="col-xs-12 col-md-3">
                  <div class="form-field">
                    <p>
                      <label>
                        <input type="checkbox" @change="changeInspeccionB" v-model="form.box.inspection"
                          :disabled="total_loss || !puede_editar_caja" />
                        <span>Inspection</span>
                      </label>
                    </p>
                  </div>
                </div>
                <div class="col-xs-12 col-md-3">
                  <div class="form-field">
                    <div class="datepicker-field datepicker-field--stretch">
                      <date-picker id="date_inspection_b" locale="es" v-model="form.box.inspection_date"
                        :disabled="total_loss || !puede_editar_caja"></date-picker>
                      <label>Date:</label>
                      <span v-if="errores['box.inspection_date']" class="helper-text text-danger" slot="helper">
                        <strong>Este campo es requerido cuando selecciona inspection</strong>
                      </span>
                    </div>
                  </div>
                </div>
                <div class="col-xs-12 col-md-3">
                  <div class="form-field">
                    <input-field stretch :disabled="total_loss || !puede_editar_caja" id="hour_man_b" v-model="form.box.hour_man">Hour Man:
                    </input-field>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12 col-md-3">
                  <div class="form-field">
                    <p>
                      <label>
                        <input type="checkbox" @change="changeEstimateB" v-model="form.box.estimate"
                          :disabled="total_loss || !puede_editar_caja" />
                        <span>Estimate</span>
                      </label>
                    </p>
                  </div>
                </div>
                <div class="col-xs-12 col-md-3">
                  <div class="form-field">
                    <div class="datepicker-field datepicker-field--stretch">
                      <date-picker id="date_estimate_b" locale="es" v-model="form.box.estimate_date"
                        :disabled="total_loss || !puede_editar_caja"></date-picker>
                      <label>Date:</label>
                      <span v-if="errores['box.estimate_date']" class="helper-text text-danger" slot="helper">
                        <strong>Este campo es requerido cuando selecciona estimate</strong>
                      </span>
                    </div>
                  </div>
                </div>
                <div class="col-xs-12 col-md-3">
                  <div class="form-field">
                    <input-field stretch vMoney :format="decimal2" :disabled="total_loss || !puede_editar_caja" id="amount_b"
                      v-model="form.box.amount">Amount:</input-field>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12 col-md-3">
                  <div class="form-field">
                    <p>
                      <label>
                        <input type="checkbox" @change="changeApprovedB" v-model="form.box.approved"
                          :disabled="total_loss || !puede_editar_caja" />
                        <span>Approved</span>
                      </label>
                    </p>
                  </div>
                </div>
                <div class="col-xs-12 col-md-3">
                  <div class="form-field">
                    <div class="datepicker-field datepicker-field--stretch">
                      <date-picker id="date_approved_b" locale="es" v-model="form.box.approved_date"
                        :disabled="total_loss || !puede_editar_caja"></date-picker>
                      <label>Date:</label>
                      <span v-if="errores['box.approved_date']" class="helper-text text-danger" slot="helper">
                        <strong>Este campo es requerido cuando selecciona approved</strong>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12 col-md-3">
                  <div class="form-field">
                    <p>
                      <label>
                        <input type="checkbox" :disabled="total_loss || !puede_editar_caja" @change="changeInvoiceB"
                          v-model="form.box.invoice" />
                        <span>Invoice</span>
                      </label>
                    </p>
                  </div>
                </div>
                <div class="col-xs-12 col-md-3">
                  <div class="form-field">
                    <div class="datepicker-field datepicker-field--stretch">
                      <date-picker id="date_invoice_b" locale="es" v-model="form.box.invoice_date"
                        :disabled="total_loss || !puede_editar_caja"></date-picker>
                      <label>Date:</label>
                      <span v-if="errores['box.invoice_date']" class="helper-text text-danger" slot="helper">
                        <strong>Este campo es requerido cuando selecciona invoice</strong>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12 col-md-3">
                  <div class="form-field">
                    <p>
                      <label>
                        <input type="checkbox" @change="changeRepairedB" v-model="form.box.repaired"
                          :disabled="total_loss || !puede_editar_caja" />
                        <span>Repaired</span>
                      </label>
                    </p>
                  </div>
                </div>
                <div class="col-xs-12 col-md-3">
                  <div class="form-field">
                    <div class="datepicker-field datepicker-field--stretch">
                      <date-picker id="date_repaired_b" locale="es" v-model="form.box.repaired_date"
                        :disabled="total_loss || !puede_editar_caja"></date-picker>
                      <label>Date:</label>
                      <span v-if="errores['box.repaired_date']" class="helper-text text-danger" slot="helper">
                        <strong>Este campo es requerido cuando selecciona repaired</strong>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12 col-md-12">
                  <div class="form-field">
                    <textarea-field stretch :disabled="total_loss || !puede_editar_caja" v-model="form.box.remarks" id="remarks_b">Remarks:
                    </textarea-field>
                  </div>
                </div>
              </div>
            </div>
          </details>

          <div class="card">
            <div class="card__content">
              <div class="row">
                <div class="col-xs-12 col-md-4">
                  <div class="form-field select2">
                    <div class="select2-field select2-field--dropdown-top select2-field--stretch">
                      <v-select id="status" label="name" @input="inputStatus" v-model="selectedStatus"
                        :options="OptionsStatus" :disabled="!puede_editar_status && total_loss && !puede_editar_in && !puede_editar_out"></v-select>
                      <label for="status">Status:</label>
                    </div>
                  </div>
                </div>
                <div class="col-xs-12 col-md-4">
                  <div class="form-field select2">
                    <div class="select2-field select2-field--dropdown-top select2-field--stretch">
                      <v-select id="type_wash" label="name" @input="inputTypeWash" v-model="selectedTypeWash"
                        :options="OptionsTypeWash" :disabled="total_loss || (!puede_editar_in && !puede_editar_out)"></v-select>
                      <label for="type_wash">Type Wash:</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <modal width="45%" height="auto" scrollable name="mostarImagen">
      <div style="text-align: center;">
          <img :src="imagePreview" class="figure-img img-fluid rounded" style="max-height: 500px;">
      </div>
    </modal>
    <modal :clickToClose="false" name="editarDetalles" width="80%" height="auto" scrollable adaptive resizable reset>
      <editar-detalles @cerrar="$modal.hide('editarDetalles')" :number="form.number" :secuencia="form.secuencia"></editar-detalles>
    </modal>
    <modal name="mostrarAtajos" width="40%" height="auto" scrollable adaptive resizable reset>
      <atajos @cerrar="$modal.hide('mostrarAtajos')" :atajos="atajos"></atajos>
    </modal>
  </div>
</template>

<script>
import EditarDetalles from './EditarDetalles.vue';
import swal from 'sweetalert2';
import InputField from "../../element/InputField.vue";
import { serialize } from 'object-to-formdata';
export default {
  components: { InputField, EditarDetalles },
  props: {
    soloEdicion: {
      type: Boolean,
      required: false,
      default: false
    },
    numeroContenedor: {
      type: String,
      required: false,
      default: "",
    },
    numeroSecuencia: {
      type: String,
      required: false,
      default: "",
    },
    historico: {
      type: Boolean,
      required: false,
      default: true,
    },
    tipo_registro: {
      required: false,
      default: ""
    },
    nuevo: {
      type: Boolean,
      required: false,
      default: false
    },
    puede_editar_status: {
      type: Boolean,
      required: false,
      default: false
    },
    puede_eliminar: {
      type: Boolean,
      required: false,
      default: false
    },
    puede_editar_gate_in: {
      type: Boolean,
      required: false,
      default: false
    },
    puede_editar_gate_out: {
      type: Boolean,
      required: false,
      default: false
    },
    puede_editar_detalles: {
      type: Boolean,
      required: false,
      default: false
    },
    puede_editar_in: {
      type: Boolean,
      required: false,
      default: false
    },
    puede_editar_out: {
      type: Boolean,
      required: false,
      default: false
    },
    puede_editar_caja: {
      type: Boolean,
      required: false,
      default: false
    },
    puede_editar_maquina: {
      type: Boolean,
      required: false,
      default: false
    },
    puede_enviar_edi_in: {
      type: Boolean,
      required: false,
      default: false
    },
    puede_enviar_edi_out: {
      type: Boolean,
      required: false,
      default: false
    },
    puede_finalizar_in: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function () {
    return {
      finalizando : false,
      patioDefault: patioDefault,
      url: url,
      errores: {},
      MostrarBotonGuardar: this.nuevo,
      total_loss: false,
      // IN
      selectedYard: null,
      yards: [],
      sizes: [],
      selectedType: null,
      types: [],
      optionsTruckingIn: [],
      optionsShipperIn: [],
      optionsVesselIn: [],
      selectedCustomer: null,
      customers: [],
      damages: [],
      modelBox: [],
      // OUT
      optionsShipperOut: [],
      optionsTruckingOut: [],
      chassis: [],
      // MAC
      modelMachine: [],
      selectedPtiType: null,
      OptionsPtiTypes: [],

      selectedStatus: null,
      OptionsStatus: [],
      selectedTypeWash: null,
      OptionsTypeWash: [
        { code: "N", name: "N - NORMAL" },
        { code: "2", name: "2 - CHEMICAL" },
        { code: "3", name: "3 - CHEMICAL" },
      ],
      outDisabled: false,
      decimal2: decimal2,
      statusAnterior: null,
      imagePreview: null,
      atajos: [],
      form: {
        solo_edicion: this.soloEdicion,
        number: "",
        secuencia: this.numeroSecuencia,
        yard_code: "",
        status_code: "",
        type_wash_code: "",
        ced_img: null,
        in: {
          turn_in: "",
          eir: "",
          eir_maquina: "",
          size: "",
          type_container_code: "",
          gate_date: "",
          tara: "",
          gross: "",
          booking: "",
          truck_co: "",
          cedula_conductor: "",
          shipper: "",
          vessel: "",
          customer_code: "",
          placa: "",
          type_dmg: "",
          model_box: "",
          remarks: "",
          raps: false,
          damage: false,
          pti: false,
          full: false,
          automatico: false,
          type: ""
        },
        out: {
          gate_date: "",
          turn_out: "",
          eir: "",
          booking: "",
          sticker_seal: "",
          vessel: "",
          bottle_pack: "",
          voyage: "",
          bottle_seal: "",
          shipper: "",
          payload: "",
          truck_co: "",
          cedula_conductor: "",
          plastic: "",
          chassis: "",
          placa: "",
          te: "",
          ventilacion: "",
          full: false,
          type: "",
          remarks: ""
        },
        mac: {
          hour_man: "",
          amount: "",
          in_servi: "",
          model_machine: "",
          pti_type_code: "",
          remarks: "",
          inspection: "",
          inspection_date: "",
          estimate: "",
          estimate_date: "",
          approved: "",
          approved_date: "",
          invoice: "",
          invoice_date: "",
          repaired: "",
          repaired_date: "",
        },
        box: {
          hour_man: "",
          amount: "",
          truck: "",
          remarks: "",
          inspection: "",
          inspection_date: "",
          estimate: "",
          estimate_date: "",
          approved: "",
          approved_date: "",
          invoice: "",
          invoice_date: "",
          repaired: "",
          repaired_date: "",
        },
      },
    };
  },
  methods: {
    inputModelMachine: function (event) {
      if (event == null) {
        this.form.mac.model_machine = '';
      }
    },
    inputChassisOut: function (event) {
      if (event == null) {
        this.form.out.chassis = '';
      }
    },
    inputTruckCoOut: function (event) {
      if (event == null) {
        this.form.out.truck_co = '';
      }
    },
    inputShipperOut: function (event) {
      if (event == null) {
        this.form.out.shipper = '';
      }
    },
    inputVessel: function (event) {
      if (event == null) 
      {
        this.form.in.vessel = '';
      }
    },
    inputShipper: function (event) {
      if (event == null) 
      {
        this.form.in.shipper = '';
      }
    },
    inputTruckCo: function (event) {
      if (event == null) 
      {
        this.form.in.truck_co = '';
      }
    },
    mostrarDetalles: function () {
      this.$modal.show('editarDetalles');
    },
    mostrarAtajos: function () {
      this.$modal.show('mostrarAtajos');
    },
    crear: function () {
      const that = this;
      swal({
        title: `¿Deseas guardar los datos?`,
        text: `La unidad será registrada. ${that.form.status_code === 'D' ? 'Advertencia: La unidad se encuentra dañada' : ''}`,
        type: "question",
        showCancelButton: true,
        confirmButtonText: `Guardar`,
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.value) {
          const options = {
            booleansAsIntegers: true,
          };
          const formData = serialize(that.form, options);
          const urlRequest = that.url + "/propiedades";
          axios
            // .post(urlRequest, that.form)
            .post(urlRequest, formData)
            .then(function ({ data }) {
              swal("Los datos han sido registrados.", "Realizado", "success");
              // that.form.number = "";
              // that.limpiar();
              if (that.tipo_registro === 'IN' || that.tipo_registro === '') {
                that.form.in.eir = data.eir_in;
                that.form.in.eir_maquina = data.eir_maquina_in;
                that.form.in.remarks = data.remark_in;
                that.MostrarBotonGuardar = false;
                that.errores = {};

                // setTimeout(() => {
                //   that.generarEDI('IN', true);
                // }, 1500);
                
                if (that.form.status_code === 'T' || that.form.status_code === 'C' || that.form.status_code === 'K') {
                  setTimeout(() => {
                    swal('El contenedor se encuentra bloqueado por total loss.', 'Advertencia', 'warning');
                    that.total_loss = true;
                  }, 1000);
                } else
                  that.total_loss = false;
              }
            })
            .catch(function (error) {
              if (error !== undefined && error !== null) {
                let response = error.response;
                if (response !== undefined && response !== null) {
                  let status = response.status;
                  if (status === 422) {
                    that.errores = response.data.errors;
                    swal("Error de validación", "Aviso", "warning");
                  }
                  else
                    swal("Hubo un error, intente nuevamente.", "Error", "error");
                }
              }
            });
        }
      });
    },
    actualizar: function () {
      const that = this;
      swal({
        title: `¿Deseas actualizar los datos?`,
        text: `La unidad será actualizada. ${that.form.status_code === 'D' ? 'Advertencia: La unidad se encuentra dañada' : ''}`,
        type: "question",
        showCancelButton: true,
        confirmButtonText: `Guardar`,
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.value) {
          that.actualizarUnidad();
        }
      });
    },
    finalizar: function () {
      this.finalizando = true;
      const that = this;
      swal({
        title: `¿Deseas finalizar la unidad?`,
        text: `La unidad será finalizada`,
        type: "question",
        showCancelButton: true,
        confirmButtonText: `Finalizar`,
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.value) {
          that.actualizarUnidad(true);
        }
      });
    },
    actualizarUnidad: function (finalizar = false) {
      const that = this;
      if (that.form.status_code === 'D' && (that.form.out.gate_date !== '' || that.form.out.gate_date !== null) && that.tipo_registro === 'OUT') {
        swal('La unidad no se puede despachar', 'La unidad se encuentra dañada', 'warning');
        return;
      }
      let urlRequest = that.url;
      if (this.historico && !this.nuevo)
        urlRequest += `/historico2/actualizar/${that.form.number}`;
      else urlRequest += `/propiedades/actualizar/${that.form.number}/${finalizar}`;
      axios
        .put(urlRequest, this.form)
        .then(function ({ data }) {
          that.finalizando = false;
          if (!finalizar) 
            swal("Los datos han sido actualizados.", "Realizado", "success");
          that.errores = {};
          if (that.tipo_registro === 'IN' || that.tipo_registro === '') {
            that.form.in.eir = data.eir_in;
            that.form.in.eir_maquina = data.eir_maquina_in;
            that.form.in.remarks = data.remark_in;
          }
          if (that.historico) {
            that.form.out.eir = data.eir_out;
          }
          else if (that.form.out.gate_date && !this.soloEdicion) {
            setTimeout(() => {
              that.generarEDI('OUT', true);
              that.limpiar();
              that.form.number = '';

            }, 1500);
            return;
          }
          // if (that.form.status_code === 'T' && that.form.out.type === 'EXP') {
          if (that.form.status_code === 'T' || that.form.status_code === 'C' || that.form.status_code === 'K') {
            setTimeout(() => {
              swal('El contenedor se encuentra bloqueado por total loss.', 'Advertencia', 'warning');
              that.total_loss = true;
            }, 1000);
          } else
            that.total_loss = false;
          if (finalizar) {
            setTimeout(() => {
              swal("La unidad fue finalizada.", "Realizado", "success");
              that.generarEDI('IN', true, true);
              // that.limpiar();
              // that.form.number = '';
            }, 1500);
            return;
          }
        })
        .catch(function (error) {
          that.finalizando = false;
          if (error !== undefined && error !== null) {
            let response = error.response;
            if (response !== undefined && response !== null) {
              let status = response.status;
              if (status === 422) {
                that.errores = response.data.errors;
                if (that.errores['contenedor'] || that.errores['in.eir']) {
                  const errorSwal = that.errores['contenedor'] || that.errores['in.eir'];
                  swal(errorSwal[0], "Advertencia", "warning");
                }
                else
                  swal("Error de validación", "Aviso", "warning");
              }
              else
                swal("Hubo un error, intente nuevamente.", "Error", "error");
            }
          }
        });
    },
    verFotos: function() {
      if (this.historico) {
        window.open(
          url + "/historico/" + this.numeroSecuencia + "/" + this.numeroContenedor,
          "_blank"
        );
      } else {
        window.open(
          url + "/contenedores/" + this.numeroContenedor,
          "_blank"
        );
      }
    },
    nuevoRegistro: function () {
      swal({
        title: "¿Desea limpiar el formulario?",
        type: "question",
        showCancelButton: true,
        confirmButtonText: "Sí",
        cancelButtonText: "No",
        focusConfirm: true
      }).then(result => {
        if (result.value) {
          this.form.number = "";
          this.limpiar();
        }
      });
    },
    cerrarUnidad: function () {
      swal({
        title: "¿Desea cerrar el formulario?",
        type: "question",
        showCancelButton: true,
        confirmButtonText: "Sí",
        cancelButtonText: "No",
        focusConfirm: true
      }).then(result => {
        if (result.value)
          this.$emit('cerrarUnidad');
      });
    },
    limpiar: function () {
      // this.form.number = "";
      this.statusAnterior = null;
      this.total_loss = false;
      this.errores = {};
      this.MostrarBotonGuardar = true;

      // select
      this.selectedType = null;
      this.selectedCustomer = null;
      this.selectedPtiType = null;
      this.selectedStatus = null;
      this.selectedTypeWash = null;
      this.selectedYard = null;

      this.form.yard_code = "";

      // IN
      this.form.in.gate_date = "";
      this.form.in.turn_in = "";
      this.form.in.eir = "";
      this.form.in.eir_maquina = "";
      this.form.in.size = "";
      this.form.in.booking = "";
      this.form.in.truck_co = "";
      this.form.in.cedula_conductor = "";
      this.form.in.shipper = "";
      this.form.in.vessel = "";
      this.form.in.customer_code = "";
      this.form.in.placa = "";
      this.form.in.type_dmg = "";
      this.form.in.remarks = "";
      this.form.in.raps = "";
      this.form.in.damage = "";
      this.form.in.pti = "";
      this.form.in.full = "";
      this.form.in.automatico = "";
      this.form.in.type = "";
      this.form.in.tara = "";
      this.form.in.gross = "";
      this.form.in.model_box = "";
      this.form.mac.in_servi = "";
      this.form.mac.model_machine = "";

      // OUT
      this.form.out.gate_date = "";
      this.form.out.turn_out = "";
      this.form.out.eir = "";
      this.form.out.booking = "";
      this.form.out.sticker_seal = "";
      this.form.out.vessel = "";
      this.form.out.bottle_pack = "";
      this.form.out.voyage = "";
      this.form.out.bottle_seal = "";
      this.form.out.shipper = "";
      this.form.out.payload = "";
      this.form.out.truck_co = "";
      this.form.out.cedula_conductor = "";
      this.form.out.plastic = "";
      this.form.out.chassis = "";
      this.form.out.placa = "";
      this.form.out.te = "";
      this.form.out.full = "";
      this.form.out.type = "";
      this.form.out.remarks = "";

      // MAC
      this.form.mac.hour_man = "";
      this.form.mac.amount = "";
      this.form.mac.pti_type_code = "";
      this.form.mac.remarks = "";
      this.form.mac.inspection = "";
      this.form.mac.inspection_date = "";
      this.form.mac.estimate = "";
      this.form.mac.estimate_date = "";
      this.form.mac.approved = "";
      this.form.mac.approved_date = "";
      this.form.mac.invoice = ""
      this.form.mac.invoice_date = "";
      this.form.mac.repaired = "";
      this.form.mac.repaired_date = "";

      // BOX
      this.form.box.hour_man = "";
      this.form.box.amount = "";
      // this.form.box.truck = data.propiedades.;
      this.form.box.remarks = "";
      this.form.box.inspection = "";
      this.form.box.inspection_date = "";
      this.form.box.estimate = "";
      this.form.box.estimate_date = "";
      this.form.box.approved = "";
      this.form.box.approved_date = "";
      this.form.box.invoice = "";
      this.form.box.invoice_date = "";
      this.form.box.repaired = ""
      this.form.box.repaired_date = "";

      this.form.status_code = "";
      this.form.type_wash_code = "";
      if (this.patioDefault != null && this.patioDefault != '' && this.nuevo) {
          for (let i = 0; i < this.yards.length; i++) {
            if (this.yards[i].code == this.patioDefault) {
              this.selectedYard = this.yards[i];
              this.inputYard();
            }
          }
      }
      if (this.tipo_registro === "IN")
        this.form.in.gate_date = moment(new Date()).format('YYYY-MM-DD HH:mm');
      else
        this.form.out.gate_date = moment(new Date()).format('YYYY-MM-DD HH:mm');
    },
    imprimirEirIn: function () {
      let secuencia = "";
      if (this.numeroSecuencia !== "")
        secuencia = "&secuencia=" + this.numeroSecuencia;
      window.open(
        this.url +
        "/propiedades/imprimirEir?eir=" +
        this.form.in.eir +
        "&tipo=in&tipo_eir=C" +
        secuencia,
        "_blank"
      );
    },
    imprimirEirOut: function () {
      let secuencia = "";
      if (this.form.secuencia !== "")
        secuencia = "&secuencia=" + this.numeroSecuencia;
      window.open(
        this.url +
        "/propiedades/imprimirEir?eir=" +
        this.form.out.eir +
        "&tipo=out" +
        secuencia,
        "_blank"
      );
    },
    imprimirEirMaquina: function () {
      let secuencia = "";
      if (this.form.secuencia !== "")
        secuencia = "&secuencia=" + this.numeroSecuencia;
      window.open(
        this.url +
        "/propiedades/imprimirEir?eir=" +
        this.form.in.eir_maquina +
        "&tipo=in&tipo_eir=M" +
        secuencia,
        "_blank"
      );
    },
    eliminarUnidad: function () {
      const that = this;
      swal({
        title: "¿Desea eliminar la unidad?",
        type: "question",
        showCancelButton: true,
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        focusConfirm: true
      }).then(result => {
        if (result.value) {
          let urlRequest = that.url;
          if (that.historico)
            urlRequest += `/historico2/${that.form.number}/${that.form.secuencia}`;
          else urlRequest += `/propiedades/${that.form.number}`;
          axios
            .delete(urlRequest)
            .then(() => {
              swal("Unidad Eliminada", "Realizado", "success");
              if (that.nuevo) {
                that.form.number = '';
                that.limpiar();
                return;
              }
              // if (location.pathname === '/contenedores') {
              //   location.replace(that.url + '/contenedores');
              //   return;
              // }
              that.$emit('eliminarUnidad');
            })
            .catch(error => {
              swal("Hubo un error, intente nuevamente.", "Error", "error");
            });
        }
      });
    },
    parseDate: function (value) {
      let format = "YYYY-MM-DD";
      value = moment(value).format(format) + ' 00:00:00';

      return moment(new Date(value)).format(format);
    },

    cargarDatos: function (buscar = false) {
      let urlRequest = this.url;
      if (this.nuevo && !buscar) {
        const detailId = document.querySelector(`#${this.tipo_registro}`);
        detailId.setAttribute('open', "")
        if (this.tipo_registro === "IN") {
          this.form.in.gate_date = moment(new Date()).format('YYYY-MM-DD HH:mm');
        }
        else {
          this.form.out.gate_date = moment(new Date()).format('YYYY-MM-DD HH:mm');
        }
        return
      }
      if (this.historico && !buscar)
        urlRequest += `/historico2/${this.form.number}/${this.numeroSecuencia}`;
      else urlRequest += `/propiedades/${this.form.number}`;
      axios
        .get(urlRequest)
        .then(({ data }) => {
          // IN
          this.cargarIn(data, buscar);
          // OUT
          if (!buscar) {
            this.cargarOut(data);
          }
          // MAC
          this.form.mac.hour_man =
            data.propiedades.man_hour_mac != null
              ? parseFloat(data.propiedades.man_hour_mac).toFixed(2)
              : "";
          this.form.mac.amount =
            data.propiedades.amount_m != null
              ? parseFloat(data.propiedades.amount_m).toFixed(2)
              : "";
          this.form.mac.pti_type_code = data.propiedades.pti_tipo;
          this.form.mac.remarks = data.propiedades.spare_parts;
          this.form.mac.inspection =
            data.propiedades.inspection_m == "S" ? true : false;
          this.form.mac.inspection_date = data.propiedades.date_i_m != null
            ? this.parseDate(data.propiedades.date_i_m) : null;
          this.form.mac.estimate =
            data.propiedades.estimado_m == "S" ? true : false;
          this.form.mac.estimate_date = data.propiedades.date_e_m != null
            ? this.parseDate(data.propiedades.date_e_m) : null;
          this.form.mac.approved =
            data.propiedades.aprobado_m == "S" ? true : false;
          this.form.mac.approved_date = data.propiedades.date_a_m != null
            ? this.parseDate(data.propiedades.date_a_m) : null;
          this.form.mac.invoice =
            data.propiedades.invoiced_machine == "S" ? true : false;
          this.form.mac.invoice_date = data.propiedades.date_f_m != null
            ? this.parseDate(data.propiedades.date_f_m) : null;
          this.form.mac.repaired =
            data.propiedades.repaired_m == "S" ? true : false;
          this.form.mac.repaired_date = data.propiedades.date_r_m != null
            ? this.parseDate(data.propiedades.date_r_m) : null;
          if (data.propiedades.equip != null) {
            this.form.mac.in_servi = data.propiedades.equip.in_service;
            this.form.mac.model_machine = data.propiedades.equip.make;
          }
          // BOX
          this.form.box.hour_man =
            data.propiedades.man_hour_box != null
              ? parseFloat(data.propiedades.man_hour_box).toFixed(2)
              : "";
          this.form.box.amount =
            data.propiedades.amount_b != null
              ? parseFloat(data.propiedades.amount_b).toFixed(2)
              : "";
          this.form.box.remarks = data.propiedades.test_on_remark;
          this.form.box.inspection =
            data.propiedades.inspection_b == "S" ? true : false;
          this.form.box.inspection_date = data.propiedades.date_i_b != null
            ? this.parseDate(data.propiedades.date_i_b) : null;
          this.form.box.estimate =
            data.propiedades.estimado_b == "S" ? true : false;
          this.form.box.estimate_date = data.propiedades.date_e_b != null
            ? this.parseDate(data.propiedades.date_e_b) : null;
          this.form.box.approved =
            data.propiedades.aprobado_b == "S" ? true : false;
          this.form.box.approved_date = data.propiedades.date_a_b != null
            ? this.parseDate(data.propiedades.date_a_b) : null;
          this.form.box.invoice =
            data.propiedades.invoiced_box == "S" ? true : false;
          this.form.box.invoice_date = data.propiedades.date_f_b != null
            ? this.parseDate(data.propiedades.date_f_b) : null;
          this.form.box.repaired =
            data.propiedades.repaired == "S" ? true : false;
          this.form.box.repaired_date = data.propiedades.repaired_date != null
            ? this.parseDate(data.propiedades.repaired_date) : null;

          this.form.yard_code = data.propiedades.yard_code;
          this.form.status_code = data.propiedades.status;
          this.form.status = data.propiedades.status;
          this.form.type_wash_code = data.propiedades.basic_wash;

          // metodos
          this.selectYard();
          this.selectPtiType();
          this.selectStatus();
          this.selectTypeWash();

          // if (data.propiedades.status === 'T' && data.propiedades.type_out === 'EXP') {
          if (data.propiedades.status === 'T' || data.propiedades.status === 'C' || data.propiedades.status === 'K') {
            swal('El contenedor se encuentra bloqueado por total loss.', 'Advertencia', 'warning');
            this.total_loss = true;
          }
          else if (data.propiedades.status === 'D')
            swal('La unidad se encuentra dañada', 'Advertencia', 'warning');
        })
        .catch((error) => {
          swal(`Ha ocurrido un error. ${error}`);
        });
    },
    cargarIn: function (data, buscar = false) {
      this.form.in.turn_in = data.propiedades.turn_in;
      this.form.in.eir = data.propiedades.eir_in;
      this.form.in.eir_maquina = data.propiedades.eir_maquina_in;
      this.form.in.size = data.propiedades.size;
      this.form.in.gate_date = data.propiedades.gate_in_date;
      this.form.in.booking = data.propiedades.kim_num_booking;
      this.form.in.truck_co = data.propiedades.trucking_in;
      this.form.in.shipper = data.propiedades.shipper_in;
      this.form.in.vessel = data.propiedades.vessel_in;
      this.form.in.placa = data.propiedades.layout;
      this.form.in.type_dmg = data.propiedades.type_damage;
      this.form.in.remarks = data.propiedades.observacion_in;
      this.form.in.raps = data.propiedades.raps == "S" ? true : false;
      this.form.in.damage = data.propiedades.in_off == "S" ? true : false;
      this.form.in.pti = data.propiedades.pti == "S" ? true : false;
      this.form.in.full = data.propiedades.sweep == "F" ? true : false;
      this.form.in.automatico = data.propiedades.fila == 1 ? true : false;
      this.form.in.type = data.propiedades.cy_sd_in;
      this.form.in.cedula_conductor = data.propiedades.cedula_conductor;
      if (data.propiedades.type_obj !== null)
        this.form.in.type_container_code = data.propiedades.type_obj.code;
      if (data.propiedades.customer !== null)
        this.form.in.customer_code = data.propiedades.customer.code;
      if (data.propiedades.equip != null) {
        this.form.in.tara = data.propiedades.equip.tara;
        this.form.in.gross = data.propiedades.equip.gross;
        this.form.in.model_box = data.propiedades.equip.model;
      }
      this.selectType();
      this.selectCustomer();
      if (buscar && data.propiedades.gate_out_date !== null)
        this.cargarOut(data);
    },
    cargarOut: function (data) {
      this.form.out.gate_date = data.propiedades.gate_out_date;
      this.form.out.turn_out = data.propiedades.turn_out;
      this.form.out.eir = data.propiedades.eir_out;
      this.form.out.booking = data.propiedades.booking;
      this.form.out.sticker_seal = data.propiedades.sello_ventolera;
      this.form.out.vessel = data.propiedades.vessel;
      this.form.out.bottle_pack = data.propiedades.sello;
      this.form.out.voyage = data.propiedades.voyage;
      this.form.out.bottle_seal = data.propiedades.genset;
      this.form.out.shipper = data.propiedades.shipper_out;
      this.form.out.payload = data.propiedades.referencia;
      this.form.out.truck_co = data.propiedades.trucking_out;
      this.form.out.cedula_conductor = data.propiedades.kim_cedula_conductor_out;
      this.form.out.plastic = data.propiedades.sello_plastico;
      this.form.out.chassis = data.propiedades.chassis_out;
      this.form.out.placa = data.propiedades.segmento;
      this.form.out.te =
        data.propiedades.monitoring != null
          ? parseFloat(data.propiedades.monitoring).toFixed(2)
          : "";
      this.form.out.ventilacion = data.propiedades.kim_ventila;
      this.form.out.full =
        data.propiedades.Conditions == "F" ? true : false;
      this.form.out.type = data.propiedades.type_out;
      this.form.out.remarks = data.propiedades.observacion;
    },
    cargarOpcionesSelect: function () {
      let urlRequest = this.url;
      if (this.historico)
        urlRequest += '/historico2';
      else urlRequest += '/propiedades';
      axios
        .get(urlRequest + '/cargar-opciones-select')
        .then(({ data }) => {
          // optionsSelect
          if (!this.historico)
            this.yards = data.yards;
          if (this.patioDefault != null && this.patioDefault != '' && this.nuevo) {
              for (let i = 0; i < this.yards.length; i++) {
                if (this.yards[i].code == this.patioDefault) {
                  this.selectedYard = this.yards[i];
                  this.inputYard();
                }
              }
          }
          this.sizes = data.sizes;
          this.types = data.types;
          this.customers = data.customers;
          this.damages = data.damages;
          this.modelBox = data.model_box;
          this.chassis = data.chassis;
          this.modelMachine = data.model_machine;
          this.OptionsPtiTypes = data.pti_tipos;
          this.OptionsStatus = data.status;
          this.cargarDatos();
        })
        .catch(error => {
          swal(`Ha ocurrido un error. ${error}`, 'Error', 'error');
        });
    },
    cargarBooking: function (booking, tipo) {
      const that = this;
      // const tipo = this.tipo_registro.toLowerCase()
      if (that.form.number === '') {
        swal('Debe ingresar la unidad', 'Advertencia', 'warning');
        that.form[tipo].booking = '';
        return;
      }
      if (that.form.yard_code === '' || that.form.yard_code === null) {
        swal('Debe seleccionar un patio', 'Advertencia', 'warning');
        that.form[tipo].booking = '';
        return;
      }
      axios.
        get(`/cargar-booking/${booking}/${that.form.yard_code}`)
        .then(({ data }) => {
          if (tipo === 'in')
            return;
          that.form.out.vessel = data.vessel;
          that.form.out.voyage = data.voyage;
          that.form.out.shipper = data.shipper;
          that.form.out.ventilacion = data.ventilation;
          that.form.out.te = data.temperature;
        })
        .catch((error) => {
          that.form[tipo].booking = '';
          if (error !== undefined && error !== null) {
            let response = error.response;
            if (response !== undefined && response !== null) {
              let status = response.status;
              if (status === 422) {
                that.errores = response.data.errors;
                if (that.errores['booking'])
                  swal(that.errores['booking'][0], "Advertencia", "warning");
                else
                  swal("Error de validación", "Aviso", "warning");
              }
              else
                swal("Hubo un error, intente nuevamente.", "Error", "error");
            }
          }
        });
    },
    cargarTurno: function (tipo) {
      // const tipo = this.tipo_registro.toLowerCase()
      const propiedad = this.form[tipo];
      if (propiedad['turn_' + tipo] === "" || propiedad['turn_' + tipo] === null || propiedad['turn_' + tipo] === "SIN TURNO")
        return;
      const parametros = {
        'tipo': tipo.toUpperCase(),
        'turno': propiedad['turn_' + tipo],
        'number': this.form.number
      }
      axios
        .get(`${this.url}/turno`, {
          params: parametros
        })
        .then(({ data }) => {
          propiedad.vessel = data[0].nave;
          propiedad.booking = data[0].booking;
          propiedad.placa = data[0].plate;
          propiedad.truck_co = data[0].driver_name;
          propiedad.cedula_conductor = data[0].driver_id;
          propiedad.shipper = data[0].cust_name;
          if (data[0].booking !== null)
            this.cargarBooking(data[0].booking, tipo);
        }).catch(error => {
          propiedad['turn_' + tipo] = '';
          if (error !== undefined && error !== null) {
            let response = error.response;
            if (response !== undefined && response !== null) {
              let status = response.status;
              if (status === 422) {
                this.errores = response.data.errors;
                if (this.errores['turno'])
                  swal(this.errores['turno'][0], "Advertencia", "warning");
                else
                  swal("Error de validación", "Aviso", "warning");
              }
              else
                swal("Hubo un error, intente nuevamente.", "Error", "error");
            }
          }
        });
    },
    generarEDI: function (tipo, generarNuevamente = true, finalizar = false) {
      const urlRequest = `${this.url}/propiedades/generarEdi/${tipo}/${this.form.number}/${generarNuevamente}`;
      axios
        .get(urlRequest)
        .then( ({data}) => {
          if (!finalizar) {
            if (data.enviado) {
              swal("EDI " + tipo + " enviado exitósamente.", "Realizado", "success");
            }
            else {
              swal("El EDI " + tipo + " no pudo ser enviado.", "Realizado", "success");
            }
          }
        })
        .catch(error => {
          if (error.response.status === 404) {
            swal('No se ha parametrizado el cliente para envío de EDI ' + tipo + '.', 'Aviso', 'warning');
          }
          else 
            swal("Hubo un error, intente nuevamente.", "Error", "error");
        });
    },
    validarNumeroContenedor: function () {
      this.form.number = this.form.number.toUpperCase();
      const number = this.form.number;
      axios
        .get(`${this.url}/propiedades/validar-contenedor/${number}`)
        .then(({ data }) => {
          this.form.in.type_container_code = "0202";
          this.form.in.size = "40";
          this.form.status_code = 'D';
          this.form.in.type_dmg = 'Box Damage';
          this.form.yard_code = data.yard;
          this.statusAnterior = null;
          this.selectYard();
          this.selectType();
          this.selectStatus();
          if (data.equip !== '') {
            const { tara, gross, model, in_service, make, equip_size, linea } = data.equip;
            this.form.in.tara = tara;
            this.form.in.gross = gross;
            this.form.in.model_box = model;
            this.form.mac.in_servi = in_service;
            this.form.mac.model_machine = make;
            this.form.in.size = equip_size != null && equip_size != '' ? equip_size : this.form.in.size;
            this.form.in.customer_code = linea;
          }
          if (this.form.in.customer_code == null || this.form.in.customer_code == '' && data.yard != null)
            this.form.in.customer_code = this.selectedYard.customer_code;
          this.selectCustomer();
        })
        .catch(error => {
          if (error !== undefined && error !== null) {
            let response = error.response;
            if (response !== undefined && response !== null) {
              let status = response.status;
              if (status === 422) {
                this.errores = response.data.errors;
                if (this.errores['number']) {
                  this.form.number = '';
                  swal(this.errores['number'][0], "Advertencia", "warning");
                }
              }
              else
                swal("Hubo un error, intente nuevamente.", "Error", "error");
            }
          }
        });
    },
    cambiarStatusAuto: function () {
      if (this.form.status_code !== '' && this.form.status_code !== 'O')
        this.statusAnterior = this.form.status_code;
      if (this.form.mac.repaired && this.form.box.repaired)
        this.form.status_code = 'O';
      else
        this.form.status_code = this.statusAnterior || 'D';
      this.selectStatus();
    },

    inputYard: function () {
      if (this.selectedYard != null) {
        this.form.yard_code = this.selectedYard.code;
        if (this.tipo_registro === 'IN') {
          this.form.in.customer_code = this.selectedYard.customer_code;
          this.selectCustomer();
        }
      }
      else this.form.yard_code = "";
    },
    inputType: function () {
      if (this.selectedType != null)
        this.form.in.type_container_code = this.selectedType.code;
      else this.form.in.type_container_code = "";
    },
    inputCustomer: function () {
      if (this.selectedCustomer != null)
        this.form.in.customer_code = this.selectedCustomer.code;
      else this.form.in.customer_code = "";
    },
    inputPtiType: function () {
      if (this.selectedPtiType != null)
        this.form.mac.pti_type_code = this.selectedPtiType.code;
      else this.form.mac.pti_type_code = "";
    },
    inputStatus: function () {
      if (this.selectedStatus != null)
        this.form.status_code = this.selectedStatus.code;
      else this.form.status_code = "";
    },
    inputTypeWash: function () {
      if (this.selectedTypeWash != null)
        this.form.type_wash_code = this.selectedTypeWash.code;
      else this.form.type_wash_code = "";
    },
    fetchTruckingIn: function (search, loading) {
      loading(true);
      let that = this;
      let oReq = new XMLHttpRequest();
      oReq.addEventListener("load", function () {
        let parseado = JSON.parse(this.responseText);
        that.optionsTruckingIn = parseado;
        loading(false);
      });
      let urlRequest = that.url;
      if (this.historico)
        urlRequest += `/historico2/optionsTrucking/${search}`
      else
        urlRequest += `/propiedades/optionsTrucking/${search}`
      oReq.open("GET", urlRequest);
      oReq.send();
    },
    fetchShipperIn: function (search, loading) {
      loading(true);
      let that = this;
      let oReq = new XMLHttpRequest();
      oReq.addEventListener("load", function () {
        let parseado = JSON.parse(this.responseText);
        that.optionsShipperIn = parseado;
        loading(false);
      });
      let urlRequest = that.url;
      if (this.historico)
        urlRequest += `/historico2/shipper/${search}`
      else
        urlRequest += `/propiedades/shipper/${search}`
      oReq.open("GET", urlRequest);
      oReq.send();
    },
    fetchVesselIn: function (search, loading) {
      loading(true);
      let that = this;
      let oReq = new XMLHttpRequest();
      oReq.addEventListener("load", function () {
        let parseado = JSON.parse(this.responseText);
        that.optionsVesselIn = parseado;
        loading(false);
      });
      let urlRequest = that.url;
      if (this.historico)
        urlRequest += `/historico2/vesselIn/${search}`
      else
        urlRequest += `/propiedades/vesselIn/${search}`
      oReq.open("GET", urlRequest);
      oReq.send();
    },
    selectType: function () {
      for (let i = 0; i < this.types.length; i++) {
        if (this.types[i].code == this.form.in.type_container_code) {
          this.selectedType = this.types[i];
          break;
        }
      }
    },
    selectYard: function () {
      for (let i = 0; i < this.yards.length; i++) {
        if (this.yards[i].code == this.form.yard_code) {
          this.selectedYard = this.yards[i];
          break;
        }
      }
    },
    selectCustomer: function () {
      for (let i = 0; i < this.customers.length; i++) {
        if (this.customers[i].code == this.form.in.customer_code) {
          this.selectedCustomer = this.customers[i];
          break;
        }
      }
    },
    selectPtiType: function () {
      for (let i = 0; i < this.OptionsPtiTypes.length; i++) {
        if (this.OptionsPtiTypes[i].code == this.form.mac.pti_type_code) {
          this.selectedPtiType = this.OptionsPtiTypes[i];
          break;
        }
      }
    },
    selectStatus: function () {
      for (let i = 0; i < this.OptionsStatus.length; i++) {
        if (this.OptionsStatus[i].code == this.form.status_code) {
          this.selectedStatus = this.OptionsStatus[i];
          break;
        }
      }
    },
    selectTypeWash: function () {
      for (let i = 0; i < this.OptionsTypeWash.length; i++) {
        if (this.OptionsTypeWash[i].code == this.form.type_wash_code) {
          this.selectedTypeWash = this.OptionsTypeWash[i];
          break;
        }
      }
    },
    fetchShipperOut: function (search, loading) {
      loading(true);
      let that = this;
      let oReq = new XMLHttpRequest();
      oReq.addEventListener("load", function () {
        let parseado = JSON.parse(this.responseText);
        that.optionsShipperOut = parseado;
        loading(false);
      });
      let urlRequest = that.url;
      if (this.historico)
        urlRequest += `/historico2/shipper/${search}`
      else
        urlRequest += `/propiedades/shipper/${search}`
      oReq.open("GET", urlRequest);
      oReq.send();
    },
    fetchTruckingOut: function (search, loading) {
      loading(true);
      let that = this;
      let oReq = new XMLHttpRequest();
      oReq.addEventListener("load", function () {
        let parseado = JSON.parse(this.responseText);
        that.optionsTruckingOut = parseado;
        loading(false);
      });
      let urlRequest = that.url;
      if (this.historico)
        urlRequest += `/historico2/optionsTrucking/${search}`
      else
        urlRequest += `/propiedades/optionsTrucking/${search}`
      oReq.open("GET", urlRequest);
      oReq.send();
    },
    changeInspeccionM: function () {
      if (this.form.mac.inspection)
        this.form.mac.inspection_date = moment(new Date()).format('YYYY-MM-DD');
      else
        this.form.mac.inspection_date = "";
    },
    changeEstimateM: function () {
      if (this.form.mac.estimate)
        this.form.mac.estimate_date = moment(new Date()).format('YYYY-MM-DD');
      else
        this.form.mac.estimate_date = "";
    },
    changeApprovedM: function () {
      if (this.form.mac.approved)
        this.form.mac.approved_date = moment(new Date()).format('YYYY-MM-DD');
      else
        this.form.mac.approved_date = "";
    },
    changeInvoiceM: function () {
      if (this.form.mac.invoice)
        this.form.mac.invoice_date = moment(new Date()).format('YYYY-MM-DD');
      else
        this.form.mac.invoice_date = "";
    },
    changeRepairedM: function () {
      if (this.form.mac.repaired)
        this.form.mac.repaired_date = moment(new Date()).format('YYYY-MM-DD');
      else
        this.form.mac.repaired_date = "";
      this.cambiarStatusAuto();
    },
    changeInspeccionB: function () {
      if (this.form.box.inspection)
        this.form.box.inspection_date = moment(new Date()).format('YYYY-MM-DD');
      else
        this.form.box.inspection_date = "";
    },
    changeEstimateB: function () {
      if (this.form.box.estimate)
        this.form.box.estimate_date = moment(new Date()).format('YYYY-MM-DD');
      else
        this.form.box.estimate_date = "";
    },
    changeApprovedB: function () {
      if (this.form.box.approved)
        this.form.box.approved_date = moment(new Date()).format('YYYY-MM-DD');
      else
        this.form.box.approved_date = "";
    },
    changeInvoiceB: function () {
      if (this.form.box.invoice)
        this.form.box.invoice_date = moment(new Date()).format('YYYY-MM-DD');
      else
        this.form.box.invoice_date = "";
    },
    changeRepairedB: function () {
      if (this.form.box.repaired)
        this.form.box.repaired_date = moment(new Date()).format('YYYY-MM-DD');
      else
        this.form.box.repaired_date = "";
      this.cambiarStatusAuto();
    },
    pressed: function (e) {
      // altKey
      // if (e.altKey && e.code === "Enter"){
      //     console.log('Ctrl + Enter pressed!');
      //     e.preventDefault();
      // }
      // if (e.altKey && e.code === "KeyE"){
      //   e.preventDefault();
      //   this.exportar();
      // }
      if (e.altKey && e.code === "KeyI"){
        e.preventDefault();
        const detailId = document.querySelector(`#IN`);
        detailId.setAttribute('open', "")
      }
      if (e.altKey && e.code === "KeyO"){
        e.preventDefault();
        const detailId = document.querySelector(`#OUT`);
        detailId.setAttribute('open', "")
      }
      if (e.altKey && e.code === "KeyM"){
        e.preventDefault();
        const detailId = document.querySelector(`#MAC`);
        detailId.setAttribute('open', "")
      }
      if (e.altKey && e.code === "KeyB"){
        e.preventDefault();
        const detailId = document.querySelector(`#BOX`);
        detailId.setAttribute('open', "")
      }

      if (e.altKey && e.code === "KeyA"){
        e.preventDefault();
        if(this.MostrarBotonGuardar)
          this.crear();
        else
          this.actualizar();
      }
      if (e.altKey && e.code === "KeyQ"){
        e.preventDefault();
        if (this.form.in.eir && !this.MostrarBotonGuardar) {
          this.imprimirEirIn();
        }
      }
      if (e.altKey && e.code === "KeyW"){
        e.preventDefault();
        if (this.form.in.eir_maquina) {
          this.imprimirEirMaquina();
        }
      }
      if (e.altKey && e.code === "KeyX"){
        e.preventDefault();
        if (this.nuevo)
          this.nuevoRegistro();
        else
          this.cerrarUnidad();
      }
    },
    imgSelected: function (e) {
      if (e.target.files[0] != undefined) {
        this.form.ced_img = e.target.files[0];
  
        let reader = new FileReader();
        reader.readAsDataURL(this.form.ced_img);
        reader.onload = e => {
          this.imagePreview = e.target.result;
        }
      } else {
          this.form.ced_img = null;
          this.imagePreview = null;
      }
    },
    mostrarImg: function () {
      this.$modal.show("mostarImagen");
    },
    llenarAtajos: function () {
      this.atajos = [
        { value: 'Alt + I', descripcion: 'Mostrar IN' },
        { value: 'Alt + O', descripcion: 'Mostrar OUT' },
        { value: 'Alt + M', descripcion: 'Mostrar Máquina' },
        { value: 'Alt + B', descripcion: 'Mostrar Caja' },
        { value: 'Alt + A', descripcion: 'Guardar/Actualizar unidad' },
        { value: 'Alt + Q', descripcion: 'Imprimir Eir IN' },
        { value: 'Alt + W', descripcion: 'Imprimir Eir Máquina' },
        { value: 'Alt + X', descripcion: 'Limpiar/Cerrar unidad' },
      ];
    }
  },

  computed: {

  },

  mounted: function () {
    // this.outDisabled = this.tipo_registro === 'IN' || (this.tipo_registro === '' && this.numeroSecuencia === '');
    this.outDisabled = this.tipo_registro === 'IN';
    if (this.numeroContenedor != "")
      this.form.number = this.numeroContenedor;
      this.cargarOpcionesSelect();
      
    const that = this;
    that.llenarAtajos();
    if (that.nuevo) {
      document.getElementById('numeroContenedor').onblur = function () {
        if (that.form.number != "") {
          axios
            .get(`${that.url}/propiedades/existe/${that.form.number}`)
            .then(({ data }) => {
              that.limpiar();
              if (that.tipo_registro === 'OUT') {
                if(data.gate_in_date === null) {
                  swal('La unidad no está registrada o ya ha salido del patio.', 'Aviso', 'warning');
                  that.form.number = "";
                  that.limpiar();
                  return;
                }
                if(data.finalizado_in !== 'S') {
                  swal('La unidad no tiene  el ingreso finalizado.', 'Aviso', 'warning');
                  that.form.number = "";
                  that.limpiar();
                  return;
                }
              }
              if (data.existe === 1) {
                that.cargarDatos(true);
                that.MostrarBotonGuardar = false;
              } else {
                that.validarNumeroContenedor();
                that.MostrarBotonGuardar = true;
              }
            }).catch(error => {
              swal(`Ha ocurrido un error. ${error}`, 'Error', 'error')
            });
        } else that.limpiar();
      }
    }
    document.getElementById('turn_in').onblur = function () {
      that.cargarTurno('in');
    }
    document.getElementById('turn_out').onblur = function () {
      that.cargarTurno('out');
    }
    document.getElementById('booking_in').onblur = function () {
      if (that.form.in.booking === "" || that.form.in.booking === null)
        return;
      that.cargarBooking(that.form.in.booking, 'in');
    }
    document.getElementById('booking_out').onblur = function () {
      if (that.form.out.booking === "" || that.form.out.booking === null)
        return;
      that.cargarBooking(that.form.out.booking, 'out');
    }
    document.addEventListener("keydown", this.pressed);
  }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/sistema/EditarUnidad.vue